<template>
  <div class="credit-card-payment-tab-component">
    <div class="columns">
      <div class="column is-10 is-offset-2">
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Número do cartão</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="cardNumber"
                  required
                  class="input"
                  type="text"
                  v-model="paymentProfile.card_number"
                  v-mask="'#### #### #### ####'"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Nome do Titular</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="cardNumber"
                  required
                  class="input"
                  type="text"
                  v-model="paymentProfile.holder_name"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Validade</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="cardNumber"
                  required
                  class="input"
                  type="text"
                  placeholder="__/____"
                  v-model="paymentProfile.card_expiration"
                  v-mask="'##/####'"
                >
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">CVV</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="cardNumber"
                  required
                  class="input hide-arrows"
                  type="number"
                  v-mask="'###'"
                  v-model="paymentProfile.card_cvv"
                >
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Parcelas</label>
              <div class="control">
                <div class="select is-primary is-fullwidth">
                  <select class="has-text-centered" v-model="paymentProfile.installments">
                    <option :value="number+1" v-for="(number) in installmentsNumbers" :key="number">
                      {{ number+1 }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12 is-flex is-justify-content-end is-align-content-end">
            <button
                class="button is-primary is-medium has-text-weight-medium is-one-third"
                @click.prevent="createPayment"
                :disabled="AppStoreStore.loading"
            >
              <span class="is-size-4">Pagar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import orderApi from '@/apis/orders'
import { mask } from 'vue-the-mask'
import { useAppStore } from "@/stores/AppStore";
import { mapStores } from 'pinia'

export default {

  name: 'credit-card-payment-tab',

  data() {
    return {
      paymentProfile: {
        holder_name: '',
        card_number: '',
        card_expiration: '',
        card_cvv: null,
        installments: null,
        payment_method_code: 'credit_card'
      },
      createdCustomer: null
    }
  },

  directives: { mask },

  props: {
    formData: {
      type: Object,
      required: true
    }
  },

  methods: {
    createPayment() {
      this.$validator.validate().then(async (result) => {
        if (result) {
          this.$flashStorage.destroyAll()
          if (this.createdCustomer === null) {
            this.createdCustomer = this.formData.customer.data
          }
          const orderData = {
            status: 1,
            customer_id: this.createdCustomer.id,
            plan_id: this.formData.plan.data.id,
            partner_id: this.formData.partner.data.id,
            message_packet_id: this.formData.messagePacket.data.id,
            quantity_message_packets: this.formData.messagePacket.data.quantity,
            is_api_cloud: this.formData.messagePacket.isApiCloud,
            extraServicePlans: [],
            seller_name: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno',
            paymentProfile: this.paymentProfile
          }

          if (this.formData.orderManagement.data.id) {
            orderData.extraServicePlans.push({
              id: this.formData.orderManagement.data.extraServicePlans[0].id,
              quantity: 1
            })
          }

          if (this.formData.recoverBannedChip.data.id) {
            orderData.extraServicePlans.push({
              id: this.formData.recoverBannedChip.data.extraServicePlans[0].id,
              quantity: 1
            })
          }

          if (this.formData.extraChips.data.id && this.formData.extraChips.data.quantity > 1) {
            orderData.extraServicePlans.push({
              id: this.formData.extraChips.data.extraServicePlans[0].id,
              quantity: (this.formData.extraChips.data.quantity - 1)
            })
          }

          if (this.formData.extraAccesses.data.id && this.formData.extraAccesses.data.quantity > this.formData.plan.data.max_accesses) {
            orderData.extraServicePlans.push({
              id: this.formData.extraAccesses.data.extraServicePlans[0].id,
              quantity: (this.formData.extraAccesses.data.quantity - this.formData.plan.data.max_accesses)
            })
          }

          if (this.formData.extraServices.data.length > 0) {
            for (const extraService of this.formData.extraServices.data) {
              orderData.extraServicePlans.push({
                id: extraService.extraServicePlans[0].id,
                quantity: extraService.quantity
              })
            }
          }

          try {
            const order = await orderApi.create(orderData);
            const orderStatus = order.integrationData.recurrent.bill.charges[0].last_transaction.status
            if (orderStatus !== 'success') {
              this.$flashStorage.destroyAll()
              this.flashError(order.integrationData.recurrent.bill.charges[0].last_transaction.gateway_message);
              return;
            }

            const appStore = useAppStore()
            appStore.orderFormData = this.formData
            appStore.order = order
            appStore.orderType = 'credit_card'
            await this.$router.push({ path: '/billet', query: {
              vendedor: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno'
            } })
          } catch (error) {
            this.$flashStorage.destroyAll()
            const errors = error.response.data.error
            for (const error of errors) {
              if (error.parameter === 'card_expiration') {
                this.flashError('A validade do cartão ' + error.message);
              } else if (error.parameter === 'card_cvv') {
                this.flashError('O CVV ' + error.message);
              } else if (error.parameter === 'holder_name') {
                this.flashError('O nome do titular ' + error.message);
              } else if (error.parameter === 'card_number') {
                this.flashError('O número do cartão ' + error.message);
              }
            }
            throw error;
          }
        } else {
          this.$flashStorage.destroyAll()
          this.flashError('Verifique se você preencheu todos os campos corretamente.');
        }
      })
    }
  },

  computed: {
    installmentsNumbers() {
      return [...Array(this.formData.plan.data.seasonality).keys()]
    },
    ...mapStores(useAppStore)
  }
}

</script>

<style lang="scss">
.credit-card-payment-tab-component {
  /* Chrome */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .button {
    border-radius: 1rem;
  }
}
</style>